import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card } from './ui/Card';
import { Status } from '../utils/readiness';
import { Badge } from './ui/Badge';
interface SectionCardProps {
  id: string;
  title: string;
  status?: Status;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function SectionCard({
  id,
  title,
  status,
  children,
  defaultOpen = true
}: SectionCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const getStatusBadge = () => {
    if (!status) return null;
    switch (status) {
      case 'Complete':
        return <Badge variant="success" data-id="element-115">Complete</Badge>;
      case 'Missing Info':
        return <Badge variant="warning" data-id="element-116">Missing Info</Badge>;
      case 'Needs Review':
        return <Badge variant="info" data-id="element-117">Needs Review</Badge>;
      case 'Blocked':
        return <Badge variant="error" data-id="element-118">Blocked</Badge>;
    }
  };
  return <Card id={id} className="mb-6 overflow-hidden scroll-mt-[var(--header-h,1.5rem)]" data-id="element-119">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 bg-slate-100 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 hover:bg-slate-200/70 dark:hover:bg-slate-900/80 transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500" data-id="element-120">
        <div className="flex items-center space-x-4" data-id="element-121">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-50" data-id="element-122">
            {title}
          </h2>
          {getStatusBadge()}
        </div>
        <div className="text-slate-500 dark:text-slate-400" data-id="element-123">
          {isOpen ? <ChevronUp className="w-5 h-5" data-id="element-124" /> : <ChevronDown className="w-5 h-5" data-id="element-125" />}
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-126">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} data-id="element-127">
            <div className="p-6 bg-white dark:bg-slate-800" data-id="element-128">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </Card>;
}